if (!customElements.get('promo-code-form')) {
  customElements.define(
    'promo-code-form',
    class PromoCodeForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.input = this.querySelector('[name="discount"]');
        this.errorElement = this.querySelector('.cart-drawer__promo-error');
        this.removeButton = this.querySelector('[data-remove-discount]');

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }
        if (this.removeButton) {
          this.removeButton.addEventListener('click', this.onRemove.bind(this));
        }
      }

      onSubmit(event) {
        event.preventDefault();
        const code = this.input.value.trim();
        if (!code) return;
        this.updateDiscount(code);
      }

      onRemove(event) {
        event.preventDefault();
        this.updateDiscount('');
      }

      setLoading(loading) {
        this.classList.toggle('cart-drawer__promo--loading', loading);
        const submitButton = this.form && this.form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = loading;
        if (this.removeButton) this.removeButton.disabled = loading;
      }

      showError() {
        if (!this.errorElement) return;
        this.errorElement.hidden = false;
      }

      clearError() {
        if (!this.errorElement) return;
        this.errorElement.hidden = true;
      }

      updateDiscount(code) {
        this.setLoading(true);
        this.clearError();

        fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((body) => {
                throw new Error(`Cart update failed (${response.status}): ${JSON.stringify(body)}`);
              });
            }
            return response.json();
          })
          .then(() => {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'promo-code-form' });
          })
          .catch((error) => {
            console.error('[promo-code-form]', error);
            this.setLoading(false);
            this.showError();
          });
      }
    },
  );
}
